import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");
export const API_BASE = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export const fetchSiteSettings = () => api.get("/site-settings").then((r) => r.data);
export const fetchPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);
export const fetchNews = () => api.get("/news").then((r) => r.data);
export const fetchResources = () => api.get("/resources").then((r) => r.data);
export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);

// PDF download — use a relative URL so it works across all preview/prod origins.
export const profilePdfUrl = () => `/api/files/profile`;
